/**
 * BCOZZY Floating Phone Button
 * ─────────────────────────────────────────────────────────────
 * Drop this snippet into any Shopify page template, section, or
 * theme.liquid (before </body>) to show a navy blue floating
 * phone button that slides in from the lower-right corner.
 *
 * CONFIGURATION — edit the two lines below:
 */
const PHONE_NUMBER   = "tel:+18886556092";   // ← your number
const TOOLTIP_TEXT   = "Call Us";            // ← tooltip label
/** ─────────────────────────────────────────────────────────── */

(function () {
  // ── Styles ──────────────────────────────────────────────────
  const css = `
    #bcozzy-phone-btn {
      position: fixed;
      bottom: 100px;
      right: 28px;
      z-index: 9999;

      display: flex;
      align-items: center;
      justify-content: center;

      width: 50px;
      height: 50px;
      border-radius: 50%;
      background-color: #1B2A6B;   /* Bcozzy navy */
      box-shadow: 0 4px 16px rgba(0,0,0,0.28);
      text-decoration: none;
      border: none;
      cursor: pointer;

      /* Slide-in animation */
      transform: translateX(120px);
      opacity: 0;
      transition: transform 0.45s cubic-bezier(0.34, 1.56, 0.64, 1),
                  opacity   0.35s ease,
                  background-color 0.2s ease,
                  box-shadow 0.2s ease;
    }

    #bcozzy-phone-btn.visible {
      transform: translateX(0);
      opacity: 1;
    }

    #bcozzy-phone-btn:hover,
    #bcozzy-phone-btn:focus {
      background-color: #243580;
      box-shadow: 0 6px 24px rgba(0,0,0,0.36);
      outline: none;
    }

    /* Subtle pulse ring 
    #bcozzy-phone-btn::after {
      content: '';
      position: absolute;
      width: 60px;
      height: 60px;
      border-radius: 50%;
      border: 2px solid rgba(27, 42, 107, 0.5);
      animation: bcozzy-pulse 2.4s ease-out infinite;
    }

    @keyframes bcozzy-pulse {
      0%   { transform: scale(1);   opacity: 0.7; }
      70%  { transform: scale(1.6); opacity: 0;   }
      100% { transform: scale(1.6); opacity: 0;   }
    } */

    /* Tooltip */
    #bcozzy-phone-btn .bcozzy-tooltip {
      position: absolute;
      right: 72px;
      background: #1B2A6B;
      color: #fff;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
      font-size: 13px;
      font-weight: 600;
      letter-spacing: 0.03em;
      white-space: nowrap;
      padding: 6px 12px;
      border-radius: 6px;
      pointer-events: none;
      opacity: 0;
      transform: translateX(6px);
      transition: opacity 0.2s ease, transform 0.2s ease;
    }

    #bcozzy-phone-btn .bcozzy-tooltip::after {
      content: '';
      position: absolute;
      top: 50%;
      right: -6px;
      transform: translateY(-50%);
      border: 6px solid transparent;
      border-right: none;
      border-left-color: #1B2A6B;
    }

    #bcozzy-phone-btn:hover .bcozzy-tooltip,
    #bcozzy-phone-btn:focus .bcozzy-tooltip {
      opacity: 1;
      transform: translateX(0);
    }

    /* Phone SVG icon */
    #bcozzy-phone-btn svg {
      width: 26px;
      height: 26px;
      fill: #ffffff;
      position: relative;  /* sits above ::after */
      z-index: 1;
    }

    /* Only show on mobile screens */
    @media (min-width: 750px) {
      #bcozzy-phone-btn { display: none !important; }
    }

    @media (max-width: 749px) {
      button[aria-label="Open chat"] {
        width: 50px !important;
        height: 50px !important;
        right: 28px !important;
        bottom: 162px !important;
      }
    }

    /* Respect reduced-motion preference */
    @media (prefers-reduced-motion: reduce) {
      #bcozzy-phone-btn { transition: none; }
      #bcozzy-phone-btn::after { animation: none; }
    }
  `;

  // ── Inject styles ────────────────────────────────────────────
  const styleEl = document.createElement("style");
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  // ── Build button ─────────────────────────────────────────────
  const btn = document.createElement("a");
  btn.id   = "bcozzy-phone-btn";
  btn.href  = PHONE_NUMBER;
  btn.setAttribute("aria-label", TOOLTIP_TEXT);
  btn.setAttribute("role", "button");

  // Phone SVG (Material Design icon, no external dependency)
  btn.innerHTML = `
    <span class="bcozzy-tooltip">${TOOLTIP_TEXT}</span>
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M6.62 10.79a15.053 15.053 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.01-.24
               c1.12.37 2.33.57 3.58.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1
               C10.61 21 3 13.39 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1
               c0 1.25.2 2.45.57 3.57a1 1 0 0 1-.25 1.01l-2.2 2.21z"/>
    </svg>
  `;

  document.body.appendChild(btn);

  // ── Slide in after short delay ───────────────────────────────
  requestAnimationFrame(() => {
    setTimeout(() => btn.classList.add("visible"), 600);
  });
})();